module.exports = require('./components/Tray');



/** WEBPACK FOOTER **
 ** ./lib/main.js
 **/